import { validateSouthAfricanIdNumber } from './taxPinAndSouthAfricanId';
import { validatePassportNumber } from './passportNumber';

export type IndividualIdType = 'SA_ID' | 'PASSPORT' | 'CUSTOMER_ID';

/** Document identifiers offered for capture; legacy Customer IDs remain readable. */
export const INDIVIDUAL_ID_TYPES: { value: IndividualIdType; label: string }[] = [
  { value: 'SA_ID', label: 'RSA ID' },
  { value: 'PASSPORT', label: 'Passport Number' },
];

/**
 * Customer ID: a historical client with no SA ID or passport on file. The customer number is the identifier and the
 * customer service fills it in, so there is nothing to type or check - and the person can never go to XDS.
 */
export const usesCustomerIdentity = (idType?: string | null): boolean => idType === 'CUSTOMER_ID';

/** Only an RSA ID or a passport can be sent to the credit bureau (owner, 22 Oct 2026). */
export const isBureauCheckable = (idType?: string | null): boolean => !usesCustomerIdentity(idType);

export function validateIndividualNumber(value: string, idType?: IndividualIdType): true | string {
  if (usesCustomerIdentity(idType)) return true;
  return idType === 'PASSPORT' ? validatePassportNumber(value) : validateSouthAfricanIdNumber(value);
}

export function validatePassportExpiry(value?: string): true | string {
  if (!value) return 'Passport expiry date is required';
  const date = new Date(`${value}T00:00:00`);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value) || Number.isNaN(date.getTime())
      || date.getFullYear() !== Number(value.slice(0, 4)) || date.getMonth() + 1 !== Number(value.slice(5, 7))
      || date.getDate() !== Number(value.slice(8, 10))) return 'Enter a valid passport expiry date';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  return date >= today || 'Passport has expired';
}
